import React from 'react';
import { cn } from '../utils';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  variant?: 'bordered' | 'ghost' | 'default';
  selectSize?: 'xs' | 'sm' | 'md' | 'lg';
  state?: 'default' | 'success' | 'warning' | 'error';
  fullWidth?: boolean;
  placeholder?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      variant = 'bordered',
      selectSize = 'md',
      state = 'default',
      fullWidth = true,
      placeholder,
      children,
      className,
      ...props
    },
    ref
  ) => {
    const selectClasses = cn(
      'select',
      variant === 'bordered' && 'select-bordered',
      variant === 'ghost' && 'select-ghost',
      selectSize === 'xs' && 'select-xs',
      selectSize === 'sm' && 'select-sm',
      selectSize === 'lg' && 'select-lg',
      state === 'success' && 'select-success',
      state === 'warning' && 'select-warning',
      state === 'error' && 'select-error',
      fullWidth && 'w-full',
      className
    );

    return (
      <select ref={ref} className={selectClasses} {...props}>
        {placeholder && (
          <option disabled value="">
            {placeholder}
          </option>
        )}
        {children}
      </select>
    );
  }
);

Select.displayName = 'Select';
